import BottomSheet from "../components/BottomSheet";
import { useCallback, useContext, useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router";
import { editInstruction, fetchCart, setDiscountStorage } from "../util/PurchaseManager";
import vouchers from "../data/vouchers.json"
import { checkVoucher } from "../api/apis";
import { useApp } from "../Context";

const ConfirmationModal = ({ showOrder, setShowOrder, removeFromCart, clear, editCart, refresh, order, sum }) => {
  const {getAuth, getCfg, sid} = useApp();
    const [instructions, setInstructions] = useState(fetchCart(sid)?.instructions ?? "");
    const [confirmClear, setConfirmClear] = useState(false)
    const [voucher, setVoucher] = useState("")
    const [voucherList, setVoucherList] = useState(null);
    const [voucherError, setVoucherError] = useState("")
    const [discount, setDiscount] = useState(0)
    const [voucherLoading, setVoucherLoading] = useState(false)
    const {restaurant} = useParams();
    const [editable, setEditable] = useState(false);
    

    async function testVoucher() {
      const trimmed = voucher.trim();
    
      // If it's the same code, treat it like a toggle (remove)
      const [currentKey] = Object.keys(voucherList || {});
      if (currentKey === trimmed) {
        setVoucherList({});
        setDiscount("0.00");
        setVoucher("");
        return;
      }
    
      setVoucherLoading(true);
      setVoucherError("");
    
      try {
        const auth = await getAuth(); // returns { phone, code } or null
        const res = await checkVoucher(trimmed, auth);
    
        if (res.ok) {
          const {voucher} = res
          const value = voucher.value;
          const newVoucher = { [trimmed]: value };
          setVoucherList(newVoucher);
    
          const discountValue = (sum * (value / 100)).toFixed(2);
          setDiscount(discountValue);
        } else {
          switch (res.code) {
            case "ITEM_NOT_FOUND":
              setVoucherError("Rabattkoden hittades inte.");
              break;
            case "AUTH_REQUIRED":
              setVoucherError("Logga in för att testa denna rabattkod.");
              break;
            case "INVALID_USER":
              setVoucherError("Rabattkoden är inaktiv ");
              break;
            case "EXPIRED_AUTHENTICATION":
              setVoucherError("Din inloggning har gått ut. Logga in igen.");
              break;
            case "INVALID_BODY":
              setVoucherError("Felaktig förfrågan – kontrollera fälten.");
              break;
            default:
              setVoucherError("Något gick fel. Försök igen.");
          }
        }
      } catch (err) {
        console.error("Voucher check failed:", err);
        setVoucherError("Tekniskt fel. Försök igen senare.");
      }
    
      setVoucher("");
      setVoucherLoading(false);
    }
    
    

    async function saveDiscount(){
      console.log("ello")
      setDiscountStorage(sid, voucherList)
    }
    
    

    useEffect(() => {
        if (showOrder) {
          getCfg().then((cfg)=>{
            setEditable(!!cfg.editable)
        })
            const storage = fetchCart(sid)

            setInstructions(storage?.instructions ?? "");
        
        } else {
            editInstruction(sid, instructions);
        }
    }, [showOrder, refresh]);

    const navigate = useNavigate();

    if(confirmClear){
        return (
            <BottomSheet
              showModal={confirmClear}
              setShowModal={setConfirmClear}
              saveAction={() => {
                clear();
                setShowOrder(false)
              }}
              showCancel={true}
              saveText="Rensa varukorg"
              headerText="Töm varukorg?"
            >
              <div className="text-center p-2">
                <p className="fs-5 mb-3">
                  Är du säker på att du vill tömma varukorgen? Denna åtgärd kan inte ångras.
                </p>
              </div>
            </BottomSheet>
          );
          
    }

    return (
        <BottomSheet
            showModal={showOrder}
            setShowModal={setShowOrder}
            headerText={"Bekräfta order"}
            saveText="Till betalning"
            saveAction={() => {
                editInstruction(sid, instructions);
                saveDiscount()
                navigate(`/${restaurant}/checkout`)
            }}
        >
            {
                order.length > 0 &&
                <div className="d-flex pb-3">
                    <button className="btn btn-outline-secondary" style={{marginLeft: "auto"}} onClick={()=>{setConfirmClear(true)}}>Rensa varukorg</button>
                </div>
            }
            
            <div className="container">
                {order.length === 0 ? (
                    <p className="text-center text-muted">Varukorgen är tom</p>
                ) : (
                    <div className="row">
                        {order.map((item, index) => (
                            <div key={index} className="col-12 mb-3">
  <div className="border rounded shadow-sm p-3 d-flex flex-column gap-2">

    {/* Top Row: Name & Price */}
    <div className="d-flex justify-content-between align-items-start">
      <div>
        <h6 className="mb-0">{item.text}{Object.keys(item?.customizations?.steps ?? {})?.length > 0 && <span className="small ms-1"> -{Object.keys(item.customizations.steps).map(s => item.customizations.steps[s].label).join(', ')}</span>}</h6>
        {item.customizations?.special?.length > 0 && (
          <small className="text-muted ms-1">
            {item.customizations.special.map(s => s.label).join(', ')}
          </small>
        )}
      </div>
      <div>
        <span className="fw-semibold text-nowrap">
          {(item.finalPrice / 100).toFixed(2)} kr
        </span>
      </div>
    </div>

    {/* Details */}
    {(item.customizations?.removed?.length > 0 ||
      item.customizations?.addons?.length > 0 ||
      item.customizations?.sides?.length > 0 ||
      item.customizations?.comment) && (
      <div className="border-start ps-3 mt-1 small">
        {item.customizations.removed?.length > 0 && (
          <p className="mb-1 text-danger">
            − {item.customizations.removed.map(i => i.label).join(', ')}
          </p>
        )}
        {item.customizations.addons?.length > 0 && (
          <p className="mb-1 text-success">
            + {item.customizations.addons.map(i => i.label).join(', ')}
          </p>
        )}
        {item.customizations.sides?.length > 0 && (
          <p className="mb-1 text-success">
            + {item.customizations.sides.map(i => i.label).join(', ')}
          </p>
        )}
        {item.customizations.comment && (
          <p className="mb-0 text-muted fst-italic">
            “{item.customizations.comment}”
          </p>
        )}
      </div>
    )}

    {/* Action Buttons */}
    <div className="d-flex justify-content-end gap-2">
      {editable && (
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => editCart(index)}
          title="Edit item"
        >
          <i className="bi bi-pencil-square" />
        </button>
      )}
      <button
        className="btn btn-sm btn-outline-danger"
        onClick={() => removeFromCart(index)}
        title="Remove item"
      >
        <i className="bi bi-trash3" />
      </button>
    </div>
  </div>
</div>

                        ))}
                    </div>
                )}

                {/* Order Information */}
                {/* 
                <div className="my-3">
                    <h6 className="mb-1">Övrig information:</h6>
                    <textarea
                        className="form-control bg-light"
                        rows="2"
                        value={instructions}
                        onChange={(e) => setInstructions(e.target.value)}
                    ></textarea>
                </div>
                */}

                {/*rabattkod*/}
                <div className="my-3">
                  <h6 className="mb-1">Rabattkod:</h6>
                  <div className="d-flex align-items-center gap-2">
                    <textarea
                      className="form-control bg-light"
                      rows="1"
                      value={voucher}
                      onChange={(e) => {
                        setVoucher(e.target.value);
                        setVoucherError("");
                      }}
                    ></textarea>
                    <button
                      className="btn btn-warning border-2 fw-semibold d-flex align-items-center"
                      disabled={voucher.length < 3 || voucherLoading}
                      onClick={testVoucher}
                    >
                      {voucherLoading && (
                        <span
                          className="spinner-border spinner-border-sm text-warning me-2"
                          role="status"
                        ></span>
                      )}
                      {voucherLoading ? "Aktiverar..." : "Aktivera"}
                    </button>
                  </div>

                  {voucherError && (
                    <div className="text-danger mt-1">
                      <p className="mb-0">{voucherError}</p>
                    </div>
                  )}

                  {voucherList && (() => {
                    const [key, value] = Object.entries(voucherList)[0];
                    return (
                      <div className="text-success fw-semibold d-flex justify-content-between px-2 mt-2">
                        <span>{key}</span>
                        <div className="d-flex gap-4">
                          <span>{value}%</span>
                          <span>{`-${(sum * (value / 100)).toFixed(2)} SEK`}</span>
                        </div>
                      </div>
                    );
                  })()}
                </div>
                {/* Order Summary */}
                {order.length > 0 && (
                    <div>
                        <hr className="m-0" />
                        <h5 className="d-flex justify-content-between pt-3">
                            <span>Totalbelopp:</span>
                            <span className="fw-bold">{(sum-discount).toFixed(2)} kr</span>
                        </h5>
                    </div>
                )}
            </div>
        </BottomSheet>
    );
};

export default ConfirmationModal;
